import { render } from "./SaveFilterPrompt.vue?vue&type=template&id=1fbcf62a&scoped=true&ts=true"
import script from "./SaveFilterPrompt.vue?vue&type=script&lang=ts"
export * from "./SaveFilterPrompt.vue?vue&type=script&lang=ts"

import "./SaveFilterPrompt.vue?vue&type=style&index=0&id=1fbcf62a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbcf62a"]])

export default __exports__